import React, { useState } from "react";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import { toast } from "react-toastify";

const libs = ["places"];

export default function AddressAutocomplete({ apiKey, onSelect }) {
  const [ac, setAc] = useState(null);
  const { isLoaded } = useJsApiLoader({ googleMapsApiKey: apiKey, libraries: libs });

  const handleLoad = (autocomplete) => {
    autocomplete.setOptions({
      componentRestrictions: { country: "au" },
      fields: ["address_components", "geometry", "name", "place_id"],
    });
    setAc(autocomplete);
  };

  const handlePlaceChanged = () => {
    if (!ac) return;
    const place = ac.getPlace();
    if (!place.geometry) {
      toast.error("Please select a valid address from suggestions.");
      return;
    }

    const comps = place.address_components || [];
    const get = (t) => comps.find((c) => c.types.includes(t))?.long_name || "";
    const loc = place.geometry.location;
    const parsed = {
      hno: get("street_number"),
      street_address: get("route"),
      suburb: get("sublocality") || get("sublocality_level_1"),
      city: get("locality"),
      state: get("administrative_area_level_1"),
      pincode: get("postal_code"),
      country: get("country"),
      latitude: loc.lat(),
      longitude: loc.lng(),
      place_id: place.place_id,
      label: place.name || "",
    };
    onSelect(parsed);
  };

  if (!isLoaded) return <div>Loading map…</div>;

  return (
    <Autocomplete onLoad={handleLoad} onPlaceChanged={handlePlaceChanged}>
      <input
        type="text"
        placeholder="Search address..."
        className="border rounded p-2 w-full"
      />
    </Autocomplete>
  );
}
